import Permissions from '@security/permissions';
import PermissionChecker from '@modules/iam/permission-checker';

export class SitePermissions {
  constructor(currentUser) {
    const permissionChecker = new PermissionChecker(
      currentUser,
    );

    this.read = permissionChecker.match(
      Permissions.values.siteRead,
    );
    this.import = permissionChecker.match(
      Permissions.values.siteImport,
    );
    this.siteAutocomplete = permissionChecker.match(
      Permissions.values.siteAutocomplete,
    );
    this.create = permissionChecker.match(
      Permissions.values.siteCreate,
    );
    this.edit = permissionChecker.match(
      Permissions.values.siteEdit,
    );
    this.destroy = permissionChecker.match(
      Permissions.values.siteDestroy,
    );
  }
}
